import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { parseCssVariable } from 'elements/_style-guide/parse-css-variable.js'
import { CSSResult, CSSResultGroup, html, LitElement, TemplateResult } from 'lit'
import { customElement } from 'lit/decorators.js'
import { style } from './spacing.style.js'


@customElement('cssg-spacing')
export class CSSGSpacing extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  private renderSpacing = (cssResult: CSSResult): TemplateResult => {
    const parsedCssResult = parseCssVariable(cssResult.cssText, this)
    return html`
      <div class="row">
        <div class="spacer" style="width:${cssResult}"></div>
        <cse-text variant="caption-m">${parsedCssResult.value}</cse-text>
        <cse-text>${parsedCssResult.variable}</cse-text>
      </div>
    `
  }

  override render(): TemplateResult {
    return html`
      <div class="spacers">
        ${Object.values(csSpacing).map(this.renderSpacing)}
      </div>
    `
  }
}


declare global {
  interface HTMLElementTagNameMap {
    'cssg-spacing': CSSGSpacing
  }
}
